export default __webpack_public_path__ + "static/media/Publications_w.db99d92d.svg";